import React, {useEffect, useState} from "react";
import {Button, Input, Layout, message, Space, Upload} from "antd";
import RegistryTable from "./components/RegistryTable.jsx";
import RegistryFormModal from "./components/RegistryFormModal.jsx";
import queryApi from "api/queryApi";
import {dataCardWithContractsTab, dataTab} from "./CardRegistryData";
import {useTranslation} from "react-i18next";
import {EyeOutlined, FileExcelOutlined, UploadOutlined} from "@ant-design/icons";
import {mapApiToForm} from "./components/api/mapApiToForm";

const SAVE_URL = 'bank_card/salary_registry/create_register'

const CardRegistryTab = () => {
    const [registries, setRegistries] = useState([]);
    const [open, setOpen] = useState(false);
    //const [fileName, setFileName] = useState('');
    const {t} = useTranslation()
    const [messageApi, contextHolder] = message.useMessage();
    const [loading, setLoading] = useState(true);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    //const [apiData, setApiData] = useState( null);
    const [mode, setMode] = useState('create');


    const getTabData = async (filter = '') => {

        let filters = [];
        if (filter!=='' && filter!== '{}') filters = filter

        const queryParams = new URLSearchParams({
            linesPerPage: pageSize,
            pageNum: currentPage,
        });

        dataTab.query['filters'] = filters;
        const { data } = await queryApi.post(`/query/paging?${queryParams.toString()}`,
            ( dataTab ));
        setRegistries(data.data);
        setTotalRows(data.totalRowCount);

        setLoading(false);
    };

    useEffect(()=>{
        getTabData()
    },[])

    const handleSaveRegistry = async (newRegistry) => {
        //setRegistries((prev) => [...prev, newRegistry]);
        setOpen(false);

        try {
            const data = await queryApi.post(SAVE_URL,

                JSON.stringify(newRegistry)
            )
            messageApi.open({
                type: 'success',
                content: 'Муввафакият',
                duration: 2,
            }).then((r)=> {
                return true
            });
        } catch (err) {
            messageApi.open({
                type: 'error',
                content: err.response?.data?.message,
                duration: 4,
            });
            return false;
            //setIsSubmitting(false);

        }
    };

    /*const handleUpload = async (file) => {
        try {
            const formData = new FormData();
            formData.append("file", file);
            console.log(file)

            const response = await queryApi.post(`/bank_card/salary_registry/loadFromExcel?contract_id=485191`,
                formData,
                {
                    headers: {
                        // Перебиваем json-умолчание queryApi: иначе axios свернёт
                        // FormData в JSON и multipart-загрузка сломается.
                        'Content-Type': 'multipart/form-data',
                        request_uri: "1.0.0/search-jur-client?clientId=101343&cardCode=1",
                    },
                }
            );

            const {data} = await response;
            console.log(data, 'datattt')
            setApiData(data);

            messageApi.open({
                type: 'success',
                content: t('fileUploadSuccess'),
                duration: 3,
            });

        } catch (err) {
            console.error(err);
            messageApi.open({
                type: 'error',
                content: t('fileUploadError'),
                duration: 4,
            });
        }
    }*/

    /*const uploadProps = {
        name: "file",
        beforeUpload: (file) => {
            setFileName(file.name);
            handleUpload(file).then(r => console.log(r,'rrr'));
            return false;
        },
        showUploadList: false,
        accept: ".xls,.xlsx"
    };

    const handleView = () => {
        setMode('view');
        setOpen(true);
    }*/

    const handleCreate = () => {
        //setApiData(null);
        setMode('create');
        setOpen(true);
    }

    const tableHeader = () => {
        return (
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 10}}>
                <Button type="primary" onClick={() => handleCreate()}>
                    {t('addRegister')}
                </Button>

                {/*<div style={{display: "flex", alignItems: "center", gap: 12}}>
                    <Upload name="fileData" {...uploadProps} style={{display: 'flex', 'gap': '10'}}>
                        <Button icon={<UploadOutlined/>}>{t('fileUpload')}</Button>
                    </Upload>

                    {fileName && (
                        <Space.Compact>
                            <Input placeholder="" style={{width: "300px"}} value={fileName} prefix={<FileExcelOutlined />} readOnly={true} />
                            <Button icon={<EyeOutlined />} onClick={() => handleView()}>{t('view')}</Button>
                        </Space.Compact>
                    )}
                </div>*/}

            </div>
        )
    }

    return (
        <>
            {contextHolder}
            <RegistryTable data={registries} loading={loading} tableHeader={tableHeader}/>

            <RegistryFormModal
                open={open}
                //initialData={apiData}
                mode={mode}
                onCancel={() => setOpen(false)}
                onSave={handleSaveRegistry}
            />

        </>
    );
};

export default CardRegistryTab;